// `Position` in ../OptionSelectBase/types.ts is LEFT | RIGHT | BOTH and is also
// the enum for `imagePosition`, so it cannot gain a HIDDEN member. A standalone
// item folds the list components' `showIndicator` boolean and
// `indicatorPosition` select into this one three-way control.
export enum IndicatorSide {
  LEFT = 'left',
  RIGHT = 'right',
  HIDDEN = 'hidden',
}

export enum SelectionMode {
  SINGLE = 'single',
  MULTI = 'multi',
}
